/**
 * Configuration
 */

const MIN_PRICE_KEYWORDS = '>|over|above|more expensive than|greater-than|greater than';
const MAX_PRICE_KEYWORDS = '<|under|below|cheaper than|cheaper|smaller-than|smaller than';
const AMOUNT_GROUP_INDEX = 3;

function getData (keywords, query) {
    if (!query) {
        return null;
    }

    const regExp = new RegExp(`(${keywords})\\s{0,1}(?:(?:\\$|USD)\\s{0,1}(\\d+)|(\\d+)\\s{0,1}(?:\\$|USD))`, 'i');
    const match = query.match(regExp);

    if (match) {
        return {
            value: match[2] ?? match[AMOUNT_GROUP_INDEX],
            newQuery: query.replace(match[0], '').replace(/\s+/g, ' ').trim(),
            matchedString: match[0],
        };
    }

    return null;
}

export default function getPricesFromQuery(query) {
    return {
        minPrice: getData(MIN_PRICE_KEYWORDS, query),
        maxPrice: getData(MAX_PRICE_KEYWORDS, query),
    };
}
